export const colors = [
  "Red",
  "Blue",
  "Yellow",
  "Green",
  "Orange",
  "Purple",
  "Black",
  "White",
  "Gray",
  "Brown",
  "Navy",
  "Pink",
  "Maroon",
  "Sliver",
  "Gold",
  "PMS",
];
